import { useQuery } from "@tanstack/react-query";

import { getDigitalAgronomistCropsRecommendation, getFarmResilienceScore } from "services";

import { GET_DIGITAL_AGRONOMIST_PREFERENCES, GET_FARM_RESILIENCE_SCORE } from "consts";

import { CropRecommendationResponse, User } from "models";

import { FarmResilienceFieldEntry } from "pages/app/resilience-score/utils/ResilienceScoreUtils";

export const useGetDigitalAgronomistPreferences = ({ user }: { user: User | null }) =>
  useQuery<CropRecommendationResponse | null>({
    queryKey: [GET_DIGITAL_AGRONOMIST_PREFERENCES, user],
    queryFn: ({ signal }) => {
      if (!user) return null;
      return getDigitalAgronomistCropsRecommendation({ signal });
    },
  });

export const useGetFarmResilienceScore = ({ farmId }: { farmId: string | null }) =>
  useQuery<FarmResilienceFieldEntry[] | null>({
    queryKey: [GET_FARM_RESILIENCE_SCORE, farmId],
    queryFn: ({ signal }) => {
      if (!farmId) return null;
      return getFarmResilienceScore({ farmId, signal });
    },
    enabled: !!farmId,
  });
